module.exports = __webpack_public_path__ + "img/airbnb-WFO-seating-s.3006a8e3.png";